import api from "../../../Component/axios";

export const useBitacoraNotificaciones = () => {
  const token = localStorage.getItem("@Token");
  const campo = localStorage.getItem("codigo_campo");
  const getNotificacion = async (fecha) => {
    try {
      const response = await api.get(
        `api/proyeccion-diaria/notificaciones/?fecha=${fecha}&campo=${campo}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const saveNotificacion = async (fecha) => {
    try {
      await api.post(
        "api/proyeccion-diaria/notificaciones/",
        {
          fecha: fecha,
          id_campo: campo,
          estatus: 1,
        },
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  return { getNotificacion, saveNotificacion };
};
